import { useCallback, useState } from 'react';

export const useLegendState = (initialLabels: string[]) => {
  const [legendStateMap, setLegendStateMap] = useState<Map<string, boolean>>(
    () => new Map(initialLabels.map((label) => [label, true]))
  );

  const handleLegendClick = useCallback((label: string) => {
    setLegendStateMap((prev) => {
      const newMap = new Map(prev);
      const currentActiveCount = Array.from(newMap.values()).filter(Boolean).length;

      if (newMap.get(label) && currentActiveCount <= 1) {
        return prev;
      }

      newMap.set(label, !newMap.get(label));
      return newMap;
    });
  }, []);

  const resetLegend = useCallback((labels: string[]) => {
    setLegendStateMap(new Map(labels.map((label) => [label, true])));
  }, []);

  return {
    legendStateMap,
    handleLegendClick,
    resetLegend,
  };
};
